import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { MLTag } from '../../shared/types/mediaLibraryTag';
import { mediaLibraryTagsApi } from '../services/MediaLibraryTagsService';

interface IMLTagsSlice {
  tags: MLTag[];
}

const initialState: IMLTagsSlice = {
  tags: [],
};

const slice = createSlice({
  name: 'mediaLibraryTags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      mediaLibraryTagsApi.endpoints.getAllMlTags.matchFulfilled,
      (state: IMLTagsSlice, { payload }) => {
        return { ...state, tags: payload.tags };
      },
    );
    builder.addMatcher(
      mediaLibraryTagsApi.endpoints.createMlTag.matchFulfilled,
      (state: IMLTagsSlice, { payload: { tag } }) => {
        return {
          ...state,
          tags: [tag, ...state.tags],
        };
      },
    );
    builder.addMatcher(
      mediaLibraryTagsApi.endpoints.deleteMlTagById.matchFulfilled,
      (state: IMLTagsSlice, { meta }) => {
        const tagId = meta.arg.originalArgs;
        return {
          ...state,
          tags: state.tags.filter((tag) => tag.id !== tagId),
        };
      },
    );
  },
});

export default slice.reducer;

export const selectMlTags = (state: RootState) => state.mediaLibraryTags.tags;
